var _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "180.12mm",
    height: "139.79mm",
    viewBox: "0 0 180.12 139.79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement(RDF, null, /*#__PURE__*/React.createElement(Work, {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("format", null, "\n\t\t\t\t\timage/svg+xml\n\t\t\t\t"), /*#__PURE__*/React.createElement("type", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("title", null))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.591 -66.639)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.591,
    y: 66.639,
    width: 180.12,
    height: 139.79,
    fill: "#d0d0d0",
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.51 133.51-34.249 34.249-15.968-15.968-41.938 41.938h152.37z",
    fill: "#fff",
    opacity: 0.675,
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.217,
    cy: 108.56,
    r: 11.773,
    fill: "#fff",
    opacity: 0.675,
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.111,
    y: 77.634,
    width: 152.61,
    height: 116.1,
    fill: "none",
    style: {
      paintOrder: "fill markers stroke"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkPlaceholder);
export default __webpack_public_path__ + "static/media/link-placeholder.e339bff373e06f66b740b427fa809d22.svg";
export { ForwardRef as ReactComponent };